/** Days a lab entry shows the "New" or "Updated" banner after its date. */
export const LAB_ACTIVITY_WINDOW_DAYS = 15;

/** @deprecated Use LAB_ACTIVITY_WINDOW_DAYS */
export const LAB_NEW_WINDOW_DAYS = LAB_ACTIVITY_WINDOW_DAYS;

/**
 * ISO date (YYYY-MM-DD) when a lab catalog entry was first added.
 * Update when you ship a new lab tool or link.
 */
export const LAB_ITEM_ADDED_AT: Partial<Record<string, string>> = {
  '/lab/understanding-your-values': '2026-06-17',
  '/lab/changing-unwanted-behaviors': '2026-06-17',
  '/lab/logical-levels-story': '2026-06-17',
  '/lab/level-aware-thinking': '2026-06-17',
  '/lab/morning-boot': '2026-06-17',
  '/lab/delegation-authority': '2026-06-17',
  '/lab/judgment-index': '2026-06-18',
  '/lab/cognitive-bias': '2026-06-18',
  '/lab/lexicon': '2026-06-18',
  '/planning': '2026-06-18',
  '/apps/mandate': '2026-06-18',
  '/brief': '2026-06-18',
  '/ladder-of-inference': '2026-06-18',
  '/johari-window': '2026-06-18',
  '/lab/whats-next': '2026-06-17',
  'http://localhost:3201': '2026-06-17',
  'http://localhost:3200': '2026-06-17',
  'http://localhost:3210': '2026-06-20',
};

/**
 * ISO date (YYYY-MM-DD) when an existing lab catalog entry was last materially updated.
 * Set when you change the tool, its lab card, or its route — not on first publish (use addedAt).
 */
export const LAB_ITEM_UPDATED_AT: Partial<Record<string, string>> = {
  '/bounded-agency-delegation': '2026-06-17',
  '/field-of-play': '2026-06-17',
  '/inquiry-sequence': '2026-06-17',
  '/lab/clarity-compass': '2026-06-17',
  '/lab/relationship-network': '2026-06-17',
  '/lab/connection-pathfinder': '2026-06-17',
  '/lab/whats-next': '2026-06-18',
  'http://localhost:3201': '2026-06-18',
  'http://localhost:3400': '2026-06-17',
  '/planning': '2026-06-29',
};

function parseLabDate(isoDate: string): Date {
  return new Date(`${isoDate}T12:00:00`);
}

function isWithinLabActivityWindow(isoDate: string, now: Date): boolean {
  const activity = parseLabDate(isoDate);
  const cutoff = new Date(now);
  cutoff.setDate(cutoff.getDate() - LAB_ACTIVITY_WINDOW_DAYS);
  cutoff.setHours(0, 0, 0, 0);
  return activity >= cutoff;
}

export function isLabItemNew(path: string, now: Date = new Date()): boolean {
  const addedAt = LAB_ITEM_ADDED_AT[path];
  if (!addedAt) return false;
  return isWithinLabActivityWindow(addedAt, now);
}

export function isLabItemUpdated(path: string, now: Date = new Date()): boolean {
  const updatedAt = LAB_ITEM_UPDATED_AT[path];
  if (!updatedAt || !isWithinLabActivityWindow(updatedAt, now)) return false;

  const addedAt = LAB_ITEM_ADDED_AT[path];
  if (!addedAt) return true;

  // Same-day publish: "New" covers it; show "Updated" only after a later touch.
  return parseLabDate(updatedAt) > parseLabDate(addedAt);
}

export type LabItemActivity = 'new' | 'updated' | null;

export function getLabItemActivity(path: string, now: Date = new Date()): LabItemActivity[] {
  const tags: LabItemActivity[] = [];
  if (isLabItemNew(path, now)) tags.push('new');
  if (isLabItemUpdated(path, now)) tags.push('updated');
  return tags;
}
